module.exports = __webpack_public_path__ + "static/media/NotoSansTC-Medium.77bb826e.ttf";